module.exports = __webpack_public_path__ + "static/media/sheets_download.88e2407b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sheets_download.svg
// module id = 1062
// module chunks = 0